module.exports = __webpack_public_path__ + "assets/img/manual-confirmation.jpg";